import { Component } from '@angular/core';

@Component({
  selector: 'app-trakii',
  templateUrl: './trakii.component.html',
})

export class TrakiiComponent {

  shop: any;
  constructor() {

  }


  ngOnInit(): any {

    }

}


